import type { TypographyProps } from './types';
import { getTruncationStyles } from './utils';
import type { PropsWithChildren } from 'react';

export function TextContent({ truncate, children }: PropsWithChildren<Pick<TypographyProps, 'truncate'>>) {
  if (truncate) {
    return (
      <span className={getTruncationStyles({ truncate })} title={typeof children === 'string' ? children : undefined}>
        {children}
      </span>
    );
  }

  return children;
}
